import React from 'react';
import PropTypes from 'prop-types';

export const ScrollableContent = ({ children, style, styles }) => (
  <div className="scrollable-content" style={style || styles.base}>
    <div className="scrollable-content-container" style={styles.container}>
      <div className="scrollable-content-body" style={styles.body}>
        {children}
      </div>
    </div>
  </div>
);

ScrollableContent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  style: PropTypes.object,
  styles: PropTypes.object
}

ScrollableContent.defaultProps = {
  styles: {}
}

export default ScrollableContent;